import { render, staticRenderFns } from "./company-content.vue?vue&type=template&id=3707b07e&scoped=true&"
import script from "./company-content.vue?vue&type=script&lang=js&"
export * from "./company-content.vue?vue&type=script&lang=js&"
import style0 from "./company-content.vue?vue&type=style&index=0&id=3707b07e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3707b07e",
  null
  
)

export default component.exports